export default __webpack_public_path__ + "static/media/icon-expand.4929db2e.svg";